/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

import React, { useState, useContext, useEffect } from "react";
import { useForm, FormProvider } from "react-hook-form";
import FormInput from "../../../components/FormInput";
import { validationRules } from "../../../utils/validationRules";
import {
  createInsuranceLoan,
  getInsuranceLoanByEmail,
  getInsuranceLoanByMobile,
  getAllStates,
  getAllPincode,
  getAllCities,
} from "../../../middleware/backend_hepler";
import { AuthContext } from "../../../Context/AuthContext";
import { useNavigate } from "react-router-dom";
import { Stepper, Step, StepLabel } from "@mui/material";
import { Row, Col, Button } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SelectInput from "../../../components/SelectInput";
import DropDownInput from "../../../components/DropDownInput";

const CreateInsuranceForm = () => {
  const { adminId, adminName } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const [states, setStates] = useState([]);
  const [filteredStates, setFilteredStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [pincodenumber, setPincode] = useState([]);
  const [pincodeOptions, setPincodeOptions] = useState([]);

  const methods = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const {
    handleSubmit,
    register,
    setValue,
    trigger,
    formState: { errors, isValid },
    clearErrors,
    watch,
  } = methods;
  const [insuranceType, setInsuranceType] = useState("");
  const [emailExists, setEmailExists] = useState(false);
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(0);
  const steps = ["Personal Details", "Loan Details", "Upload Documents"];
  const [mobileExists, setMobileExists] = useState(false);

  const handleStepChange = async (newStep) => {
    if (newStep > activeStep) {
      const isValid = await trigger();
      if (isValid) {
        if (emailExists) {
          toast.error("Email already exists. Please use a different email.");
          return;
        }

        if (mobileExists) {
          toast.error(
            "Mobile number already exists. Please use a different mobile number."
          );
          return;
        }

        setActiveStep(newStep);
      }
    } else {
      setActiveStep(newStep);
    }
  };

  useEffect(() => {
    const fetchStates = async () => {
      try {
        const statesData = await getAllStates();
        const availableStates = statesData.filter(
          (state) => state.availability === "Yes"
        );
        setStates(availableStates);
        setFilteredStates(availableStates);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching states data:", error);
        setLoading(false);
      }
    };
    fetchStates();
  }, []);

  const stateOptions = filteredStates.map((state) => ({
    value: state.name,
    label: state.name,
  }));

  useEffect(() => {
    const fetchCities = async () => {
      try {
        const citiesData = await getAllCities();
        citiesData.sort((a, b) => a.name.localeCompare(b.name));
        const tamilNaduCities = citiesData.filter(
          (city) => city.State_name === "Tamil Nadu"
        );

        const options = tamilNaduCities.map((city) => ({
          value: city.name,
          label: city.name,
        }));
        setCities(tamilNaduCities);
        setCityOptions(options);
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    };
    fetchCities();
  }, []);

  useEffect(() => {
    const fetchPinCode = async () => {
      try {
        const pincodeData = await getAllPincode();

        const tamilNaduStates = pincodeData.filter(
          (pincode) => pincode.state === "TAMIL NADU"
        );

        const uniquePincodes = new Set();
        const uniqueOptions = [];

        tamilNaduStates.forEach((pincode) => {
          if (!uniquePincodes.has(pincode.pincode)) {
            uniquePincodes.add(pincode.pincode);
            uniqueOptions.push({
              value: pincode.pincode,
              label: pincode.pincode,
            });
          }
        });
        uniqueOptions.sort((a, b) => a.value - b.value);
        setPincode(tamilNaduStates);
        setPincodeOptions(uniqueOptions);
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    };
    fetchPinCode();
  }, []);

  const checkEmail = async (email) => {
    if (email) {
      try {
        const data = await getInsuranceLoanByEmail(email);
        setEmailExists(Boolean(data));
      } catch (error) {
        setEmailExists(false);
      }
    }
  };

  const checkMobile = async (mobile) => {
    if (mobile) {
      try {
        const data = await getInsuranceLoanByMobile(mobile);
        setMobileExists(Boolean(data));
      } catch (error) {
        setMobileExists(false);
      }
    }
  };
  const handleNextStep = async () => {
    const isStepValid = await trigger();
    if (isStepValid) {
      setActiveStep((prevStep) => prevStep + 1);
    }
  };

  const watchedInsuranceType = watch("insurance_type");

  useEffect(() => {
    if (watchedInsuranceType) {
      setInsuranceType(watchedInsuranceType);

      clearErrors();

      switch (watchedInsuranceType) {
        case "Health Insurance":
          setValue("patient_marital_status", "", { shouldValidate: true });
          setValue("health_insurance_coverage_amount", "", {
            shouldValidate: true,
          });
          setValue("co_name", "", { shouldValidate: true });
          setValue("co_dob", "", { shouldValidate: true });
          setValue("co_gender", "", { shouldValidate: true });
          setValue("co_mobile", "", { shouldValidate: true });
          break;
        case "General Insurance":
          setValue("general_insurance_policy_number", "", {
            shouldValidate: true,
          });
          setValue("general_insurance_provider", "", { shouldValidate: true });
          setValue("general_coverage_amount", "", { shouldValidate: true });
          break;
        case "Life Insurance":
          setValue("life_insurance_policy_number", "", {
            shouldValidate: true,
          });
          setValue("life_coverage_amount", "", { shouldValidate: true });
          setValue("policy_type", "", { shouldValidate: true });
          setValue("purpose_for_seeking", "", { shouldValidate: true });
          setValue("employment", "", { shouldValidate: true });
          setValue("occupation", "", { shouldValidate: true });
          setValue("annual_income", "", { shouldValidate: true });
          setValue("primary_name", "", { shouldValidate: true });
          setValue("primary_dob", "", { shouldValidate: true });
          setValue("primary_relationship", "", { shouldValidate: true });
          setValue("primary_percentage", "", { shouldValidate: true });
          setValue("secondary_name", "", { shouldValidate: true });
          setValue("secondary_dob", "", { shouldValidate: true });
          setValue("secondary_relationship", "", { shouldValidate: true });
          setValue("secondary_percentage", "", { shouldValidate: true });
          setValue("secondary_parent1", "", { shouldValidate: true });
          setValue("cause_of_death1", "", { shouldValidate: false });
          setValue("secondary_parent2", "", { shouldValidate: true });
          setValue("cause_of_death2", "", { shouldValidate: false });
          setValue("are_you_taking_medications", "", { shouldValidate: true });
          setValue("medication", "", { shouldValidate: true });
          setValue("any_bankruptcy", "", { shouldValidate: true });
          setValue("bankruptcy_explanation", "", { shouldValidate: false });
          setValue("medical_history", "", { shouldValidate: true });
          setValue("medical_history_explanations", "", {
            shouldValidate: false,
          });
          break;
        default:
          break;
      }
    }
  }, [watchedInsuranceType, setValue, clearErrors]);

  const handleFileChange = (event) => {
    console.log(event.target.files);
  };

  const onSubmit = (data) => {
    console.log("Submitting data:", data);
    data.created_by = adminName;
    data.created_id = adminId;

    data.status = data.status || "open";
    data.assigned_to = data.assigned_to || "";

    const formData = new FormData();

    Object.keys(data).forEach((key) => {
      if (
        key === "bankStatement" ||
        key === "salarySlip" ||
        key === "incomeCertificate"
      ) {
        if (data[key][0]) {
          formData.append(key, data[key][0]);
        }
      } else {
        formData.append(key, data[key]);
      }
    });

    createInsuranceLoan(formData)
      .then((response) => {
        console.log("Insurance loan application submitted:", response);
        navigate("/insurancelist", {
          state: { successMessage: "Insurance loan created successfully!" },
        });
      })
      .catch((error) => {
        const errorMessage = error.response?.data?.message;
  
        if (typeof errorMessage === "string") {
          if (errorMessage.includes("Email already exists")) {
            toast.error("Email already exists. Please use a different email.");
          } else if (errorMessage.includes("Mobile number already exists")) {
            toast.error("Mobile number already exists. Please use a different mobile number.");
          } else {
            console.error("Error submitting loan application:", errorMessage);
            toast.error("Failed to submit loan application. Please try again.");
          }
        } else {
          console.error("Error submitting loan application:", error);
          toast.error("Failed to submit loan application. Please try again.");
        }
      });
  };

  const email = watch("email");
  const mobile = watch("mobile");

  React.useEffect(() => {
    if (email) {
      checkEmail(email);
    }
  }, [email]);

  React.useEffect(() => {
    if (mobile) {
      checkMobile(mobile);
    }
  }, [mobile]);

  return (
    <div className="container">
      {activeStep === 0 && (
        <div className="edit-back-icon">
            <div 
                className="edit-back-text"
                onClick={() => navigate("/insurancelist")}>
                &lt; Go Back 
            </div>
        </div>
    )}
      <h2 className="my-4">Insurance</h2>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)} className="form-group">
          <Stepper
            activeStep={activeStep}
            alternativeLabel
            className="stepper-container"
          >
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <div className="form-content">
            {activeStep === 0 && (
              <div className="sections personal-details-sections">
                <h4>Personal Details</h4>
                <div className="form-row">
                  <FormInput
                    name="name"
                    label="Name"
                    registerOptions={validationRules.name}
                    error={errors.name?.message}
                  />
                  <FormInput
                    name="dob"
                    label="Date of Birth"
                    type="date"
                    registerOptions={{
                      required: "Date of Birth is required",
                      validate: {
                        isOldEnough: (value) => {
                          const today = new Date();
                          const minAgeDate = new Date();
                          minAgeDate.setFullYear(today.getFullYear() - 21);
                          return (
                            new Date(value) <= minAgeDate ||
                            "You must be at least 21 years old"
                          );
                        },
                        isNotFutureDate: (value) => {
                          return (
                            new Date(value) <= new Date() ||
                            "Date of Birth cannot be in the future"
                          );
                        },
                      },
                    }}
                    error={errors.dob?.message}
                  />
                </div>
                <div className="form-row">
                  <FormInput
                    name="age"
                    label="Age"
                    type="number"
                    registerOptions={validationRules.age}
                    error={errors.age?.message}
                  />
                  <DropDownInput
                    name="gender"
                    label="Gender"
                    options={[
                      { value: "Male", label: "Male" },
                      { value: "Female", label: "Female" },
                    ]}
                    register={register}
                    registerOptions={{ required: "Gender is required" }}
                    error={errors.gender?.message}
                  />
                </div>
                <div className="form-row">
                  <FormInput
                    name="mobile1"
                    label="Mobile"
                    type="tel"
                    registerOptions={validationRules.mobile}
                    error={
                      mobileExists
                        ? "Mobile number already exists"
                        : errors.mobile?.message
                    }
                  />
                  <FormInput
                    name="mobile2"
                    label="Phone Number(home)"
                    type="tel"
                    registerOptions={validationRules.mobile}
                    error={errors.mobile2?.message}
                  />
                </div>
                <div className="form-row">
                  <FormInput
                    name="email"
                    label="Email ID"
                    registerOptions={validationRules.email}
                    error={errors.email?.message}
                  />
                  <FormInput
                    name="address_1"
                    label="Address"
                    register={register}
                    registerOptions={{ required: "Street address is required" }}
                    error={errors.address_1?.message}
                  />
                </div>
                <div className="form-row">
                  <SelectInput
                    name="state"
                    label="State"
                    options={stateOptions}
                    registerOptions={{ required: "State is required" }}
                    error={errors.state?.message}
                  />
                  <SelectInput
                    name="city"
                    label="City"
                    register={register}
                    options={cityOptions}
                    registerOptions={{ required: "City is required" }}
                    error={errors.city?.message}
                  />
                </div>
                <div className="form-row">
                  <DropDownInput
                    name="employee_type"
                    label="Employee Type"
                    options={[
                      { value: "salaried", label: "Salaried" },
                      { value: "self employed", label: "Self Employed" },
                    ]}
                    registerOptions={{ required: "Employee Type is required" }}
                  />
                  <SelectInput
                    name="pincode"
                    label="Pincode"
                    options={pincodeOptions}
                    registerOptions={{ required: "Pincode is required" }}
                    rules={{ required: "Pincode is required" }}
                  />
                </div>

              </div>
            )}
            {activeStep === 1 && (
              <div className="sections">
                <DropDownInput
                  name="insurance_type"
                  label="Insurance Types"
                  options={[
                    { value: "Health Insurance", label: "Health Insurance" },
                    { value: "General Insurance", label: "General Insurance" },
                    { value: "Life Insurance", label: "Life Insurance" },
                  ]}
                  register={register}
                  registerOptions={{ required: "Selection is required" }}
                  error={errors.insurance_type?.message}
                // onChange={(e) => setValue("insurance_type", e.target.value)}
                />
                {insuranceType === "Health Insurance" && (
                  <div className="sections health-insurance-sections">
                    <h4>Health Insurance Loan </h4>
                    <div className="form-row">
                      <DropDownInput
                        name="patient_marital_status"
                        label="Patient Marital Status"
                        options={[
                          { value: "Single", label: "Single" },
                          { value: "Married", label: "Married" },
                          { value: "Student", label: "Student" },
                          { value: "Widow", label: "Widow" },
                        ]}
                        registerOptions={{ required: "Selection is required" }}
                        error={errors.patient_marital_status?.message}
                      />
                      <FormInput
                        name="health_insurance_coverage_amount"
                        label="Health Insurance Coverage Amount"
                        type="number"
                        registerOptions={{
                          required: "Coverage Amount is required",
                        }}
                        error={errors.health_insurance_coverage_amount?.message}
                      />
                    </div>
                    <div className="form-row">
                      <FormInput
                        name="co_name"
                        label="Name of Co-applicant"
                        registerOptions={{
                          required: "Co-applicant name is required",
                        }}
                        error={errors.co_name?.message}
                      />

                      <FormInput
                        name="co_dob"
                        label="Date of Birth"
                        type="date"
                        registerOptions={{
                          required: "Date of Birth is required",
                          validate: {
                            isOldEnough: (value) => {
                              const today = new Date();
                              const minAgeDate = new Date();
                              minAgeDate.setFullYear(today.getFullYear() - 21);
                              return (
                                new Date(value) <= minAgeDate ||
                                "You must be at least 21 years old"
                              );
                            },
                            isNotFutureDate: (value) => {
                              return (
                                new Date(value) <= new Date() ||
                                "Date of Birth cannot be in the future"
                              );
                            },
                          },
                        }}
                        error={errors.co_dob?.message}
                      />
                    </div>
                    <div className="form-row">
                      <DropDownInput
                        name="co_gender"
                        label="Gender of Co-applicant"
                        options={[
                          { value: "Male", label: "Male" },
                          { value: "Female", label: "Female" },
                        ]}
                        register={register}
                        registerOptions={{ required: "Gender is required" }}
                        error={errors.co_gender?.message}
                      />
                      <FormInput
                        name="co_mobile"
                        label="Phone Number(Mobile) of Co-applicant"
                        type="tel"
                        registerOptions={validationRules.mobile}
                        error={errors.co_mobile?.message}
                      />
                    </div>
                  </div>
                )}
                {insuranceType === "General Insurance" && (
                  <div className="general-insurance-sections">
                    <h4>General Insurance Loan </h4>
                    <div className="form-row">
                      <FormInput
                        name="general_insurance_policy_number"
                        label="Policy Number"
                        registerOptions={{ required: "Policy Number is required" }}
                        error={errors.general_insurance_policy_number?.message}
                      />
                      <FormInput
                        name="general_insurance_provider"
                        label="Insurance Provider"
                        registerOptions={{
                          required: "Insurance Provider is required",
                        }}
                      // error={errors.pincode?.message}
                      />
                    </div>
                    <FormInput
                      name="general_coverage_amount"
                      label="Coverage Amount"
                      type="number"
                      registerOptions={{ required: "Coverage Amount is required" }}
                      error={errors.general_coverage_amount?.message}
                    />
                  </div>
                )}
                {insuranceType === "Life Insurance" && (
                  <div className="life-insurance-sections">
                    <h4>Life Insurance Loan </h4>
                    <div className="form-row">
                      <FormInput
                        name="life_insurance_policy_number"
                        label="Policy Number"
                        registerOptions={{ required: "Policy Number is required" }}
                        error={errors.life_insurance_policy_number?.message}
                      />
                      <FormInput
                        name="life_coverage_amount"
                        label="Coverage Amount"
                        type="number"
                        registerOptions={{
                          required: "Coverage Amount is required",
                        }}
                        error={errors.life_coverage_amount?.message}
                      />
                    </div>
                    <div className="form-row">
                      <DropDownInput
                        name="policy_type"
                        label="Policy Type"
                        options={[
                          { value: "10-year term", label: "10-year term" },
                          { value: "20-year term", label: "20-year term" },
                          { value: "30-year term", label: "30-year term" },
                          { value: "Index", label: "Index" },
                          { value: "Whole Life", label: "Whole Life" },
                          {
                            value: "Variable Universal",
                            label: "Variable Universal",
                          },
                          { value: "Universal life", label: "Universal life" },
                        ]}
                        registerOptions={{ required: "Policy Type is required" }}
                        error={errors.policy_type?.message}
                      />
                      <DropDownInput
                        name="purpose_for_seeking"
                        label="Purpose for Seeking life Insurance"
                        options={[
                          {
                            value: "Family Protection",
                            label: "Family Protection",
                          },
                          { value: "Debt Protection", label: "Debt Protection" },
                          { value: "Estate Planning", label: "Estate Planning" },
                          {
                            value: "Business Buy-Sell Funding",
                            label: "Business Buy-Sell Funding",
                          },
                          {
                            value: "Business Key Person Protection",
                            label: "Business Key Person Protection",
                          },
                        ]}
                        registerOptions={{ required: "Purpose is required" }}
                        error={errors.purpose_for_seeking?.message}
                      />
                    </div>
                    <div className="form-row">
                      <DropDownInput
                        name="employment"
                        label="Employment Status"
                        options={[
                          { value: "Employee", label: "Employee" },
                          { value: "Self-Employed", label: "Self-Employed" },
                          { value: "Unemployed", label: "Unemployed" },
                        ]}
                        registerOptions={{
                          required: "Employment Status is required",
                        }}
                        error={errors.employment?.message}
                      />
                      <FormInput
                        name="occupation"
                        label="Occupation"
                        registerOptions={{ required: "Occupation is required" }}
                        error={errors.occupation?.message}
                      />
                    </div>
                    <div className="form-row">
                      <FormInput
                        name="annual_income"
                        label="Annual Income"
                        type="number"
                        registerOptions={{ required: "Annual Income is required" }}
                        error={errors.annual_income?.message}
                      />
                      <FormInput
                        name="primary_name"
                        label="Primary Beneficiary Name"
                        registerOptions={{
                          required: "Primary Beneficiary Name is required",
                        }}
                        error={errors.primary_name?.message}
                      />
                    </div>
                    <div className="form-row">
                      <FormInput
                        name="primary_dob"
                        label="Primary Date of Birth"
                        type="date"
                        registerOptions={{
                          required: "Primary Beneficiary Date of Birth is required",
                          validate: {
                            isOldEnough: (value) => {
                              const today = new Date();
                              const minAgeDate = new Date();
                              minAgeDate.setFullYear(today.getFullYear() - 21);
                              return (
                                new Date(value) <= minAgeDate ||
                                "You must be at least 21 years old"
                              );
                            },
                            isNotFutureDate: (value) => {
                              return (
                                new Date(value) <= new Date() ||
                                "Date of Birth cannot be in the future"
                              );
                            },
                          },
                        }}
                        error={errors.primary_dob?.message}
                      />
                      <FormInput
                        name="primary_relationship"
                        label="Primary Beneficiary Relationship"
                        registerOptions={{
                          required: "Primary Beneficiary Relationship",
                        }}
                        error={errors.primary_relationship?.message}
                      />
                    </div>
                    <div className="form-row">
                      <FormInput
                        name="primary_percentage"
                        label="Primary Beneficiary Percentage"
                        type="number"
                        registerOptions={{
                          required: "Primary Beneficiary Percentage is required",
                        }}
                        error={errors.primary_percentage?.message}
                      />
                      <FormInput
                        name="secondary_name"
                        label="Secondary Beneficiary Name"
                        registerOptions={{
                          required: "Secondary Beneficiary Name is required",
                        }}
                        error={errors.secondary_name?.message}
                      />
                    </div>
                    <div className="form-row">
                      <FormInput
                        name="secondary_dob"
                        label="Secondary Beneficiary Date of Birth"
                        type="date"
                        registerOptions={{
                          required:
                            "Secondary Beneficiary Date of Birth is required",
                          validate: {
                            isOldEnough: (value) => {
                              const today = new Date();
                              const minAgeDate = new Date();
                              minAgeDate.setFullYear(today.getFullYear() - 21);
                              return (
                                new Date(value) <= minAgeDate ||
                                "You must be at least 21 years old"
                              );
                            },
                            isNotFutureDate: (value) => {
                              return (
                                new Date(value) <= new Date() ||
                                "Date of Birth cannot be in the future"
                              );
                            },
                          },
                        }}
                        error={errors.secondary_dob?.message}
                      />
                      <FormInput
                        name="secondary_relationship"
                        label="Secondary Beneficiary Relationship"
                        registerOptions={{
                          required:
                            "Secondary Beneficiary Relationship is required",
                        }}
                        error={errors.secondary_relationship?.message}
                      />
                    </div>
                    <div className="form-row">
                      <FormInput
                        name="secondary_percentage"
                        label="Secondary Beneficiary Percentage"
                        type="number"
                        registerOptions={{
                          required: "Secondary Beneficiary Percentage is required",
                        }}
                        error={errors.secondary_percentage?.message}
                      />
                      <DropDownInput
                        name="secondary_parent1"
                        label="Parent 1"
                        options={[
                          { value: "Living", label: "Living" },
                          { value: "Deceased", label: "Deceased" },
                        ]}
                        registerOptions={{
                          required: "Secondary Parent 1 is required",
                        }}
                        error={errors.secondary_parent1?.message}
                      />
                    </div>
                    <div className="form-row">
                      <FormInput
                        name="cause_of_death1"
                        label="Cause of Death 1"
                        registerOptions={{
                          required: "Cause of Death 1 is required",
                        }}
                        error={errors.cause_of_death1?.message}
                      />
                      <DropDownInput
                        name="secondary_parent2"
                        label="Parent 2"
                        options={[
                          { value: "Living", label: "Living" },
                          { value: "Deceased", label: "Deceased" },
                        ]}
                        registerOptions={{
                          required: "Secondary Parent 2 is required",
                        }}
                        error={errors.secondary_parent2?.message}
                      />
                    </div>
                    <div className="form-row">
                      <FormInput
                        name="cause_of_death2"
                        label="Cause of Death 2"
                        registerOptions={{
                          required: "Cause of Death 2 is required",
                        }}
                        error={errors.cause_of_death2?.message}
                      />
                      <DropDownInput
                        name="are_you_taking_medications"
                        label="Are you taking any medications?"
                        options={[
                          { value: "Yes", label: "Yes" },
                          { value: "No", label: "No" },
                        ]}
                        registerOptions={{ required: "Selection is required" }}
                        error={errors.are_you_taking_medications?.message}
                      />
                    </div>
                    <div className="form-row">
                      <FormInput
                        name="medication"
                        label="Medications and dosage"
                        registerOptions={{
                          required: "Medication Details are required",
                        }}
                        error={errors.medication?.message}
                      />
                      <DropDownInput
                        name="any_bankruptcy"
                        label="Any Bankruptcy?"
                        options={[
                          { value: "Yes", label: "Yes" },
                          { value: "No", label: "No" },
                        ]}
                        registerOptions={{ required: "Selection is required" }}
                        error={errors.any_bankruptcy?.message}
                      />
                    </div>
                    <div className="form-row">
                      <FormInput
                        name="bankruptcy_explanation"
                        label="Bankruptcy Explanation"
                        registerOptions={{ required: "Explanation is required" }}
                        error={errors.bankruptcy_explanation?.message}
                      />
                      <FormInput
                        name="medical_history_explanations"
                        label="Medical History Explanations"
                        registerOptions={{
                          required: "Medical History Explanations are required",
                        }}
                        error={errors.medical_history_explanations?.message}
                      />
                    </div>
                    <DropDownInput
                      name="medical_history"
                      label="Medical history:  Have you ever been told you had, or been treated for any of the following conditions? Only check if yes."
                      options={[
                        { value: "Alcohol Abuse", label: "Alcohol Abuse" },
                        { value: "Alzheimer's", label: "Alzheimer's" },
                        { value: "Asthma", label: "Asthma" },
                        { value: "Cancer", label: "Cancer" },
                        { value: "Diabetes", label: "Diabetes" },
                        { value: "Drug Abuse", label: "Drug Abuse" },
                        { value: "Kidney Disease", label: "Kidney Disease" },
                        { value: "Lupus", label: "Lupus" },
                        { value: "Stroke/TIA", label: "Stroke/TIA" },
                        {
                          value: "Neck, Back, Spine Injury",
                          label: "Neck, Back, Spine Injury",
                        },
                        { value: "Other", label: "Other" },
                      ]}
                      register={register}
                      registerOptions={{ required: "Selection is required" }}
                      error={errors.medical_history?.message}
                    />
                  </div>
                )}
              </div>
            )}
          </div>
          {activeStep === 2 && (
            <div className="sections financial-details-sections">
              <div className="form-row">
                <div className="sections document-upload-sections">
                  {["bankStatement", "salarySlip", "incomeCertificate"].map(
                    (doc, idx) => (
                      <div className="document-upload-group" key={idx}>
                        <div className="document-label-container">
                          <label htmlFor={doc} className="document-label">
                            {doc.split(/(?=[A-Z])/).join(" ")}
                          </label>
                        </div>
                        <div className="document-file-container">
                          <input
                            type="file"
                            id={doc}
                            className="form-control-file"
                            {...methods.register(doc)}
                            onChange={handleFileChange}
                          />
                        </div>
                      </div>
                    )
                  )}
                </div>
              </div>
            </div>
          )}
          <div className="button-container">
            <Row className="mt-4">
              <Col className="text-end">
                {activeStep > 0 && (
                  <Button
                    variant="secondary"
                    onClick={() => handleStepChange(activeStep - 1)}
                    className="custom-back-button"
                  >
                    Go Back
                  </Button>
                )}
                {activeStep < steps.length - 1 && (
                  <Button
                    variant="primary"
                    onClick={() => handleStepChange(activeStep + 1)}
                    className="custom-next-button"
                  >
                    Next Step
                  </Button>
                )}
                {activeStep === steps.length - 1 && (
                  <Button
                    type="submit"
                    variant="primary"
                    className="custom-submit-button"
                  >
                    Submit
                  </Button>
                )}
              </Col>
            </Row>
          </div>
        </form>
      </FormProvider>
      <ToastContainer />
    </div>
  );
};

export default CreateInsuranceForm;
